/**
 * 利用時の注意点テキスト（スクロール確認用）
 */
export const USAGE_NOTES_TEXT = 
`・月額の会員維持費は、その月にご利用の有無にかかわらず発生いたします。

・初期費用として鍵発行費用と初月月額会員維持費の合計が発生いたします。
　＊クレジット決済ご指定の場合、登録と同時に決済されます。
　＊口座振替決済ご指定の場合、初期費用は銀行振込となります。

・施設の最低利用時間は1時間とし30分だけのご利用はできません。1時間超から30分毎に利用料が発生します。
　1.5時間のご利用の際は2時間の枠をご予約いただき、実際の入店退店の時間により1.5時間もしくは2時間にて計算されます。

・ご予約時間が開始後のキャンセルはできません。
　キャンセルがされていない場合、ご利用の有無にかかわらず通常料金が発生いたします。

・予約時間終了までには片付けをすべて終えて、次の方に台を引渡しするよう、余裕をもって時間管理をお願いします。
　時間ギリギリまで練習すると片づけの時間がなくなり、次の方にご迷惑となりますのでご注意ください。

・会員はゲストの同伴も可能です。1台あたりのゲスト上限人数は店舗ごとに異なるため、各店舗ページをご確認ください。
　＊ゲストは卓トレ会員である必要はございません。

・毎月、1時間の「無料利用権」が付与されますが、翌月に繰越はできません。
　また各店のキャンペーンにより無料利用権の時間は変動がありますので、各店舗ページをご確認ください。

・課金の前提となる施設利用時間は、入退場の記録と予約履歴を参照し確定いたします。
　（着替えや準備の時間として、ご予約の前後10分はカットさせていただいております。）

・予約された時間よりも早めに練習を切り上げた場合も、ご予約された時間分の料金が発生いたします。
　（例：3時間の予約をしたにもかかわらず1時間しか利用しなかった場合、2.5時間の計算となります）

・ご退場の際には、ピンポン玉をマシンにすべて戻し、備えのクロス等で台上や床の汗を拭いていただきますようお願いします。
　マシンを外して練習された場合は必ずマシンを再設置お願いします。
　次にご利用の会員様が気持ちよくご利用できるようご協力をお願いいたします。

・未成年の方は保護者の同意と保証が入会の条件となります。`;

/**
 * 会員規約セクションのサブタイトルテキスト
 */
export const TERMS_SUBTITLE_TEXT = '卓トレ会員規約の内容をすべて確認のうえ合意お願いいたします。';

/**
 * 会員規約テキスト（スクロール確認用）
 */
export const MEMBER_TERMS_TEXT = `『卓トレ』会員 規約

【名称及び所在地】
第1条
本施設の名称・所在地は本文末尾および当施設ＨＰ（https://taku-tore.com）に明記します。（以下「本施設」といいます）

【運 営】
第2条
本施設の運営・管理（会員資格の得喪変更、会費・諸費用の収受、会員規約の制定・改廃等の決定手続きを含む）は株式会社石原不動産が行います。

【目 的】
第3条
本施設は、入会された会員が本施設内の施設を利用して心身の健康の維持・増進を図るとともに会員相互の親睦を密にし、品位ある生活を楽しむことを目的とします。

【入会資格】
第4条
①本施設に入会できる方は、別に定める会員加入の各要件を満たし、本施設の趣旨に賛同し本規約を承諾した方とします。（以下「会員」といいます）
②刺青、タトゥー及びこれに類するものが入っている方、暴力団構成員、会員の円滑な施設利用に支障を来す可能性がある方、その他本施設が不適当と認める方は、入会資格がありません。また、入会後であってもこれらの事象が判明した時点で退会していただきます。

【会員の種類】
第5条
本施設の会員種類及び各要件は別に定める通りです。

【入会手続】
第6条
①本施設に入会する方は所定の入会手続きを行い、本施設の承認を得た上、定める会費・入会諸費用をお支払いいただきます。
②入会する本人が未成年者の場合は、保護者の連帯保証を必要とします。この場合保護者は、自ら会員になった場合と同様に本規約に基づく責任を本人と連帯して負担し、本規約第20条に定める危険負担と本施設の免責につき同意するものとします。

【入会金】
第7条
会員は、本施設の定める入会金を、所定の方法で本施設に支払わなければなりません。なお、当該入会金は、入会契約締結及び会員管理のための必要費用であり、一旦納入した入会金は返還しません。（＊キャンペーン期間中を除く）

【鍵の発行と管理】
第8条
①会員には本施設の入退出を管理する、固有ＩＤを含んだ電子鍵を貸与します。その場合、入会時に鍵発行費を支払います。
②会員は、自らの責任において電子鍵を管理します。他人に貸与することは禁止します。万が一、紛失・過失による破損・滅失があった場合、再発行の費用が発生します。
③退会時には、貸与されていた電子鍵を事務局に返却します。但し、物理的な鍵の発行が行われていない場合はその限りではありません。

【資格停止及び除名】
第9条
本施設は、会員が次の各号の一つに該当すると認めた場合は、会員資格の一時停止または除名をすることができます。
一 本施設の定める会費・諸費用につき、2ヶ月以上滞納したとき。（除名の場合も除名以前の会費・諸費用は全て納入していただきます。）
二 本施設の施設を故意に毀損したとき。
三 本規約、その他本施設が定める規則に違反したとき。
四 本施設の名誉、信用を毀損し、または秩序を乱したとき。
五 入会書類に虚偽を記載したことが判明したとき。
六 会員として品位を損なうと認められる非行があったとき。
七 伝染病等他人に伝染・感染するおそれのある疾病に罹患したとき。
八 本施設の合理的な指示・指導に従わないとき。
九 その他本施設が、社会通念に照らし、本施設会員としてふさわしくないと認めたとき。

【会員資格の喪失】
第10条
会員は、退会、除名、死亡及び失踪宣言をうけたとき、その資格を失います。会員が資格を喪失した場合には、本施設から貸与されている物品がある場合には速やかに返還してください。

【会員資格の譲渡禁止】
第11条
会員は、その会員資格を他に譲渡すること（相続を含みます）はできません。

【会費等の支払】
第12条
会員は、本施設の定める会費等を所定の方法で支払わなければなりません。会費等の種類、金額、支払期限及び支払方法等は本施設が定めるものとします。
（会員維持費は、会員が本施設の会員資格を有する限り、現実に本施設の施設を利用しない場合も支払い義務が発生します）

【施設利用料】
第13条
会員は、本施設を利用する場合、その定められた施設利用料を支払わなければなりません。

【退 会】
第14条
会員は、各月の10日までに本施設に退会の申し出を、直接・メール・郵便等で提出（本施設到着ベース）することにより、その月末限りで退会することができます。電話等口頭での退会は受け付けません。10日を過ぎた場合は、本施設の事務手続き上、翌月末日扱いになります。なお、通信エラーなど含め、当社の責によらない理由により本施設が退会申し出を受領しない場合、および会員がカードキー返却など退会手続きを完了しない場合、会費支払義務は継続するものとします。

【ゲストの利用】
第15条
①本施設は、会員の同伴により会員以外の方（以下「ゲスト」といいます）に本施設を利用させることができます。1台あたりのゲスト上限人数は店舗ごとに異なります。ゲストは、本施設の施設を利用するにあたり、本規約第18条に準ずるものとします。なお、同時に複数台を利用する場合のゲスト可能数は都度相談となります。
②前項の規定にかかわらず、本施設は必要に応じてゲストの入場制限をすることができるものとします。なお、ゲストの料金、その他に関する規則は別に本施設が定めます。

【休 業】
第16条
本施設は、原則として年中無休で運営します。しかし、諸施設の補修、会場整備、その他本施設の都合により休業することがあります。なお、休業に関してのお知らせは原則として2週間前までに通知します。ただし、施設安全管理の面から緊急工事が必要な場合など緊急の事態が発生した場合には、あらかじめ通知することなく一部または全部の施設を休業することができるものとします。

【施設の廃止・利用制限等】
第17条
①本施設は、次の事由により本施設の一部または全部を閉鎖または臨時休業することができます。
一 台風その他異常気象、風水火災害、地震、近隣の事故等で本施設の業務遂行に支障があるとき。
二 施設の改造または補修工事実施のとき。
三 法令の制度改廃、行政指導、社会情勢、経済状況の著しい変化があったとき。
四 施設の使用権限が消滅する等運営に影響が生ずる事情が発生したとき。
五 その他閉鎖または臨時休業の必要があると認められるとき。

【会員の利用及び事故】
第18条
①会員は、自己の責任と危険負担において、他の会員と協調して、本施設の施設を利用するものとします。
②本施設は、会員が本施設の施設利用中に生じた盗難、怪我その他の事故について、本施設に故意もしくは重大な過失がない限り、一切の責任は負いません。会員同士の本施設内外でのトラブルについても同様とします。
③会員は、本施設において、技量を超えた行為及び危険行為は行ってはならないものとします。

【責任事項】
第19条
①会員およびゲストは、自身の故意または過失により施設設備の破損等をした場合、損害賠償責任を負います。
②会員は、本施設が会員制であることを認識し、同伴したゲストの本施設内における行為、施設に対する支払い及び事故等一切につき、連帯責任を負うものとします。

【変更事項】
第20条
会員は、住所または連絡先・メールアドレス等入会申込書記入事項に変更のあった場合は速やかに届け出るものとします。届け出が未済であることにより会員が被った不都合について、施設は一切の責任を負いません。

【諸費用の改定】
第21条
本施設は、本規約に基づいて会員が負担すべき諸費用を、社会情勢・経済状況・税率の変動等を参考にして改定することができます。この場合、本施設は当社ホームページ・登録メールへの配信等にて会員に告知するものとします。

【細 則】
第22条
本規約に定めていない事項及び業務遂行上必要な細則は本施設が定めるものとします。

【改 定】
第23条
本規約の改定及び変更は本施設により為されるものとし、その効力は当該改定及び変更時に在籍する全ての会員に及ぶものとします。

【附 則】
第24条
本規約は2015年4月29日より施行します。（2015年5月6日改定 2019年8月1日改定 2020年5月1日改定 2021年1月1日改定 2025年11月14日改定）

【名称及び所在地】
名 称：株式会社石原不動産
住 所：福島県会津若松市中央1-5-29 B.Step203
その他 加盟店名称・所在地はHP記載の通り 但し御徒町店は除く


━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

『卓トレ』 利用時の注意点と合意事項 (統合版）
2025.11.14改訂

【１．入会について】
①当施設は無人管理です。きめ細やかなサービスはできない代わりに、高性能卓球マシンを安価にいつでもご自由に利用して頂けます。会員全員の大事な設備ですので、愛情をもってご利用頂きたいと存じます。
②月額料金は、クレジットカードもしくは口座振替による後払いになります。（初期費用を除く） クレジットカードもしくは口座振替用の銀行口座を専用画面から登録していただきます。

【２．予約について】
①施設利用の前には、必ずWEBの予約サイトから予約をお願いします。予約なしでご利用されていて、後から予約された方が来店された場合、予約者が優先されます。
②予約のキャンセルも、WEBの予約サイトからキャンセルしてください。 キャンセル料の発生はありませんが、直前のキャンセルが続いた場合、会員登録を取り消しさせて頂く場合もあるのでご注意下さい。予約時間がスタート後のキャンセルはできません。その際は原則通常使用料金が発生いたします。
③予約枠は１時間ごとの枠になっていますので、最初から１．５時間の練習をしたいときは、２時間分の枠を予約して頂いて結構です。（２時間枠を予約して１時間だけの利用は不可。例：１時30分から2時30分の利用など。この場合は１．５時間のご利用カウントとなります。）
④同時刻で複数台の予約も可能です。貸切も可能で、その際のご利用人数上限はご相談ください。

【３．施設の利用について】
①『卓トレ』は、会員様毎の固有の電子鍵（スマートロック、カードキー等）により、入退出の履歴管理を行います。入退出の際には、必ず一人づつご自身の鍵にて入退出をお願いします。入り口はオートロックです。一時退出の際に、鍵の持ち出しを忘れぬようご注意ください。スマートロック利用の店舗で鍵となるスマートフォンをお持ちでない場合、別途専用の暗証番号もしくはICカードを発行いたします。
②ご退場の際には、次にご利用になる方のためにピンポン球をマシンに全て戻して頂き、備え付けのクロスで卓球台を軽く拭いて頂きますようお願いします。また、床の汗等が目立つときも、次の方のために雑巾で軽く床を拭いてください。卓球マシンを取り外して練習された場合、必ずマシンを元通りに再設置してください。次のご利用の会員様が、気持ちよくご利用できるようご配慮をお願いいたします。
③施設内は禁煙で、火気の持込はおやめ下さい。ベランダ等も禁煙です。
④音楽機器、録画装置等の持込は自由ですが、他人に迷惑にならぬようご配慮下さい。
⑤安全と防犯のため、施設内には防犯カメラを設置させて頂いております。事故や不正等のトラブル時以外に、そのデータを使用することは一切ございません。
⑥施設内備品の持ち出しはおやめ下さい。
⑦設備の利用は常識な利用をお願いします。故意もしくは過失、非常識な利用法により設備の破損・破壊があった場合には、損害賠償請求の対象となりますのでご注意下さい。
⑧会員はゲストの同伴も可能です。1台あたりのゲスト上限人数は店舗ごとに異なるため、各店舗のHPをご確認ください。＊ゲストは卓トレ会員である必要はございません。空いていても予約していない台のご利用は不可です。もし無断でご利用が判明した場合、別途ご利用料金が発生いたします。
⑨ピンポン球の踏みつけによる破損がないよう、ご協力をお願い致します。あまりに多くのボールを一度に使用しますと床がボールだらけになり踏みつけが頻発します。わずかな意識で大きくコストが変わりますので、よろしくお願いいたします。
⑩スマートロック、カードキー、個別暗証番号などを第三者へ貸与、譲渡、開示することは固く禁止させて頂きます。
⑪全台原則、二人打ちも可です。但し、マシンの取り外し、再設置をご自身で適切に行っていただけることが条件となりますので、ご注意ください。（＊店舗によりマシン練習専用台もありますのでご注意ください。）
⑫個人契約ロッカーがありますので、ご希望の方はお申し付けください。（一部店舗除く）

【４．マシントラブルについて】
①当店は無人店舗につき、卓球マシンのトラブル（故障）が発生した場合、即時対応ができません。トラブル発生時には、別の台が空いている場合は、空いている台をご利用ください。（１台店舗除く）万が一、他のすべての台がご利用中の場合、途中でマシン練習ができなくなる可能性がございます。その可能性についてあらかじめご了承をお願いいたします。
②万が一、マシントラブル発生した場合、「故障した」旨を店舗責任者までご一報をお願いします。（連絡先は店舗内に掲示）そのあと故障した台を予約されている会員様に連絡し、台の振替やキャンセル確認などの手続きが必要ですので、お手数ですがご協力お願いいたします。

【５．料金体系について】
①<strike>入会金は、6,000円（税別）です。 入会金は事務手数料を含んでおり途中解約されても返金はございません。</strike>
<campaign>入会金無料CP実施中！</campaign>
②施設利用料金は店舗ごとに異なりますので、詳細は卓トレHPの各店舗ページにてご確認ください。最低利用時間は１時間とし、以降３０分毎に料金が発生します。
③初期費用として電子鍵発行費用が発生いたします。（各店舗ごとの料金は卓トレHPにて）また会員管理費（月額会費）が発生しますが、毎月１時間分の無料施設利用権を付与させて頂きます。(無料施設利用権は追加店では適用になりません。また翌月に繰り越しできません。）
④課金の前提となる各会員の施設利用実績は、電子鍵の入退出履歴が原則となり、状況により予約履歴等を考慮して確定致します。月末締め翌月10日過ぎに前月利用料金明細を電子メールにてお送りします。また、お着替えやご準備のためのお時間として、ご予約の前後１０分はカットさせて頂いております。（例：10時〜11時のご予約であれば、９：５０〜１１：１０を目途に、ご入場・ご退場をお願いしております。）

【６．退会について】
①毎月１０日までに退会申出を提出頂いた場合、当月末の解約となります。それ以降の提出は翌月扱いとなるのでご注意下さい。 入会金・管理費の返金はございません。各所属店舗に、問い合わせページ・メールLINE等で直接退会の連絡をしていただき、各店舗の指示に従って手続きをお願いします（予約サイトのご自身のアカウントを削除しただけでは退会となりません）

【７．その他】
①一部携帯キャリアによって、特定のメールが受信拒否設定となっている場合があります。受信側の設定状況によりメール不着となったことで会員に不都合が発生した場合、当施設は一切の責任を負いません。（事前に「＠gmail.com」「＠reserva.be」「＠takutore.page」「＠akerun.com」のドメインを受信できるよう設定お願いします。）
②一部店舗は「卓トレ」本部とライセンス契約を締結した事業者が運営する、パートナー店舗であり、それら店舗でのサービス提供はパートナ―事業者と本部が連携して行います。従いまして、サービス提供のために必要な個人情報等については本部とパートナー事業者間で共有されますのでご承知おきください。
③未成年の方は、保護者の連帯保証が入会の条件となります。決済方法は、保護者のクレジットカード決済のみとさせて頂きます。`;

/**
 * 会員規約を別タブで表示するためのHTMLテンプレートを生成
 * @param {string} termsText - 会員規約のテキスト
 * @returns {string} HTML文字列
 */
export const generateTermsHTML = (termsText) => {
  // カスタムタグをHTMLに変換
  const formattedText = termsText
    .replace(/<strike>/g, '<span style="text-decoration: line-through;">')
    .replace(/<\/strike>/g, '</span>')
    .replace(
      /<campaign>/g, 
      '<span style="display: inline-block; border: 1.5px solid #e53935; color: #e53935; padding: 2px 8px; margin-left: 12px; font-size: 11px; font-weight: bold; border-radius: 3px;">'
    )
    .replace(/<\/campaign>/g, '</span>')
    .replace(/\n/g, '<br>');

  return `
    <!DOCTYPE html>
    <html lang="ja">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>卓トレ会員規約</title>
      <style>
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
          max-width: 900px;
          margin: 0 auto;
          padding: 40px 20px;
          line-height: 1.8;
          color: #333;
        }
        h1 {
          font-size: 24px;
          font-weight: bold;
          color: #007bff;
          margin-bottom: 30px;
          text-align: center;
          border-bottom: 3px solid #007bff;
          padding-bottom: 15px;
        }
        .content {
          white-space: pre-wrap;
          font-size: 14px;
        }
        .print-button {
          position: fixed;
          top: 20px;
          right: 20px;
          padding: 10px 20px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
          z-index: 1000;
        }
        .print-button:hover {
          background-color: #0056b3;
        }
        @media print {
          .print-button {
            display: none;
          }
        }
      </style>
    </head>
    <body>
      <button class="print-button" onclick="window.print()">印刷する</button>
      <h1>卓トレ会員規約</h1>
      <div class="content">${formattedText}</div>
    </body>
    </html>
  `;
};